import { Component, Inject, inject } from '@angular/core';
import { MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { RedirectRequest } from '@azure/msal-browser';
import { JwtStateService, SigninForm }from '@net3-multiplatform-client/libs';
import { environment } from 'apps/web/src/environments/environment';

@Component({
  selector: 'app-sign-in',
  imports: [
    SigninForm,
],
  templateUrl: './sign-in.component.html',
  styleUrl: './sign-in.component.scss'
})
export class SignIn {

  private jwtStateService = inject(JwtStateService);

  constructor(
    private authMsalService: MsalService,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration
  ){}

  loginRedirect() {
    // Descartem tokens de la sessió anterior perquè no es reutilitzin al següent exchange.
    localStorage.removeItem('token');
    this.jwtStateService.clearJwt();

    const request: RedirectRequest = {
      scopes: environment.apiConfig.scopes,
      redirectStartPage: "/communities",
      prompt: 'select_account'
    };
    if (this.msalGuardConfig.authRequest){
      this.authMsalService.loginRedirect(request);
    } else {
      this.authMsalService.loginRedirect();
    }
  }

}
